import { render, staticRenderFns } from "./ArtistDetails.vue?vue&type=template&id=693b5d18&scoped=true&"
import script from "./ArtistDetails.vue?vue&type=script&lang=js&"
export * from "./ArtistDetails.vue?vue&type=script&lang=js&"
import style0 from "./ArtistDetails.vue?vue&type=style&index=0&id=693b5d18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "693b5d18",
  null
  
)

export default component.exports